var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 981 985.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#442114;}.cls-3{fill:#10283a;}.cls-4{fill:#173856;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#091c28;}.cls-7{fill:#fbbcaa;}.cls-8{fill:#20456e;}.cls-9{fill:#639;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-517 -611)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1113.41,1503.37v65.23c0,29.06-99,29.06-99,0v-61.93C1012.26,1462.71,1111.26,1459.4,1113.41,1503.37Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bas frame 3 f") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bas_f_3",
    "data-name": "bas f 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1007.66,647.41c0-2.87-.25-19.41-.25-21.41,34,0,81,4,90.87,38.25,46.48,20.4,84,60.11,92.22,123.75,1.91,42-5.09,39-15.09,42-8.21,33.38-14.41,77-32,100a223.08,223.08,0,0,1-24.17,27c-14.46,13.6-36.21,6.73-51.24,14-31.06,15-43.28,18.26-57,17C1011,949.2,1007.66,731,1007.66,647.41Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1008.41,647.41c0-2.87.25-19.41.25-21.41-34,0-81,4-90.87,38.25-46.48,20.4-83.95,60.11-92.22,123.75-1.91,42,5.09,39,15.09,42,8.21,33.38,14.41,77,32,100a223.08,223.08,0,0,0,24.17,27c14.46,13.6,34.14,12.73,49.17,20,31.06,15,51.28,12.26,65,11C1011,949.2,1008.41,731,1008.41,647.41Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M987.41,1506v70c0,26.91-67,26.91-67,0v-74Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1007.41,1248l12,275c-2.15-53.29,86.85-57.29,89-4l-11-267Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1113.41,1503.37l-5,65.63c0,29.06-90,29.06-90,0l-4-62.33C1012.26,1462.71,1111.26,1459.4,1113.41,1503.37Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1113.41,1521.76c0-29.9-99-29.9-99,0l-3-25.82,34-30.56,53,.83,38,13.21,3,19.82Z",
    transform: "translate(-517 -611)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M916.41,1252v241c0,34.27,80,34.27,80,0l17-155-5.75-86Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1146.44,1166c-5.12-20.85-62.12-6.85-57,14,0,0,3,38,37,32S1146.44,1166,1146.44,1166Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1081.41,1019.54c22.59.39,40.5,9.34,49,35.46l22,107c0,36-68,41-68,14Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1097.59,1252.5v-203s0-50-90.59-50-90.59,40-90.59,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 916.41,
    y: 1244,
    width: 181,
    height: 9,
    transform: "translate(1496.82 1886) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1010.41,1033c22.07-3.49,40.42-10.38,50-25.29-4.28-6.19-9.41-11.82-25-10.6l-15-.11-4.51,2.79C1057.47,1008.23,1034.81,1020.56,1010.41,1033Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1002.41,1032.89c-22.07-3.49-40.42-10.39-50-25.29,4.29-6.19,9.41-11.83,25-10.6l15-.11,4.51,2.79C955.36,1008.12,978,1020.45,1002.41,1032.89Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M815,836.19c14-20.19,23.41-3.79,23.41-5.69a169,169,0,0,1,168.59-169h.41A169,169,0,0,1,1176,830.5c0,1.9,9.41-14.5,23.41,5.69,7.72,11.13,8.89,57.77-9,76.81-14.55,15.49-33,24-45.38,15a168.78,168.78,0,0,1-137.62,71.45H1007A168.78,168.78,0,0,1,869.38,928c-12.38,9-30.83.45-45.38-15C806.11,894,807.28,847.32,815,836.19Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M931.44,1016.54c-22.58.39-40.49,9.34-49,35.46l-22,107c0,36,68,41,68,14Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M866.41,1163c5.12-20.85,62.12-6.85,57,14,0,0-3,38-37,32S866.41,1163,866.41,1163Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M825.57,788C838.87,685.67,927.65,645.22,1008,647.4c80.39-2.18,169.17,38.27,182.47,140.6,1.91,42-5.09,39-15.09,42-6,13-15,13-20,10-6-10-24-33-29-60-4.29-5.52-11.11-29.76-21-32-37.8-8.57-82.42-10.92-97-10.88h-.75c-14.58,0-59.2,2.31-97,10.88-9.89,2.24-16.71,26.48-21,32-6.25,34-28.37,48.06-29,60-5,3-14,3-20-10C830.66,827,823.66,830,825.57,788Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cadre_invisible",
    "data-name": "cadre invisible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomFrame3);
export default __webpack_public_path__ + "static/media/bottom_frame_3.52b61b0271e12bfdaca4f875554df5df.svg";
export { ForwardRef as ReactComponent };